import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full hidden md:flex justify-center bg-white"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "bg-white p-6 dark:bg-gray-900 dark:text-gray-100" }
const _hoisted_5 = { class: "w-full h-full max-w-7xl xl:mx-auto flex flex-wrap gap-4 items-center" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col grow sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3 sm:justify-center items-center lg:mt-0 order-last lg:order-none w-full lg:w-auto"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("View")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatsGalleryLogo = _resolveComponent("StatsGalleryLogo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SmallTextInput = _resolveComponent("SmallTextInput")!
  const _component_SmallTimeframeInput = _resolveComponent("SmallTimeframeInput")!
  const _component_SmallNetworkInput = _resolveComponent("SmallNetworkInput")!
  const _component_SmallPrimaryButton = _resolveComponent("SmallPrimaryButton")!
  const _component_UserMenu = _resolveComponent("UserMenu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!!_ctx.bannerImagePath)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            href: _ctx.bannerHref,
            target: "_blank",
            rel: "noreferrer"
          }, [
            _createElementVNode("img", {
              class: "max-h-12",
              src: _ctx.bannerImagePath,
              alt: "Announcement banner"
            }, null, 8, _hoisted_3)
          ], 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("nav", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: { name: 'landing' },
          class: "flex items-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_StatsGalleryLogo, { class: "p-1 h-9" })
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: { name: 'story' } }, {
          default: _withCtx(({ isActive }) => [
            _createElementVNode("span", {
              class: _normalizeClass([[
            isActive
              ? 'text-gray-700 bg-gray-400 dark:text-gray-50'
              : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-50',
          ], "font-medium rounded px-3 py-1 bg-opacity-20"])
            }, "story", 2)
          ]),
          _: 1
        }),
        (_ctx.showIntake)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_SmallTextInput, {
                placeholder: "my-account.near",
                class: "w-full sm:w-48",
                modelValue: _ctx.displayedAccount,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.displayedAccount) = $event)),
                onSubmit: _ctx.update
              }, null, 8, ["modelValue", "onSubmit"]),
              _createVNode(_component_SmallTimeframeInput, {
                class: "w-full sm:w-24",
                modelValue: _ctx.selectedTimeframe,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTimeframe) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_SmallNetworkInput, {
                class: "w-full sm:w-32",
                modelValue: _ctx.selectedNetwork,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedNetwork) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_SmallPrimaryButton, {
                class: "w-full sm:w-24",
                onClick: _ctx.update
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showIntake)
          ? (_openBlock(), _createBlock(_component_UserMenu, { key: 1 }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}